import { render, staticRenderFns } from "./FullReportModal.vue?vue&type=template&id=050a4ab6"
import script from "./FullReportModal.vue?vue&type=script&lang=js"
export * from "./FullReportModal.vue?vue&type=script&lang=js"
import style0 from "./FullReportModal.vue?vue&type=style&index=0&id=050a4ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports